import { useQuery } from '@tanstack/react-query';
import { api } from '@/api/apiClient';
import { useAuth } from '@/lib/AuthContext';
export function useAssistantNavigation() {
  const { user } = useAuth();
  const { data } = useQuery({ queryKey: ['assistant-navigation', user?.id || user?._id], queryFn: () => api.request('GET', '/api/mcp/navigation'), enabled: Boolean(user), staleTime: 30000, refetchInterval: 60000 });
  return { visible: data?.assistant_navigation_enabled === true, chat: data?.chat_enabled === true };
}
